/* FMH storefront interactions: accessible collection tabs, persistent save hearts. */
(function(){
  function initTabs(root){
    if(root.dataset.fmhReady==='1')return;
    root.dataset.fmhReady='1';
    var tabs=Array.from(root.querySelectorAll('[role="tab"][data-tab]'));
    tabs.forEach(function(tab){tab.addEventListener('click',function(){
      tabs.forEach(function(t){var active=t===tab;t.classList.toggle('is-active',active);t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});
      root.querySelectorAll('[role="tabpanel"][data-panel]').forEach(function(panel){panel.hidden=panel.dataset.panel!==tab.dataset.tab;});
    });
    tab.addEventListener('keydown',function(e){var i=tabs.indexOf(tab);var n=e.key==='ArrowRight'?(i+1)%tabs.length:e.key==='ArrowLeft'?(i+tabs.length-1)%tabs.length:null;if(n!==null){e.preventDefault();tabs[n].focus();tabs[n].click();}});
    });
  }
  function saved(){try{return JSON.parse(localStorage.getItem('fmh-saved-products')||'{}')||{};}catch(e){return {};}}
  function updateHearts(){var items=saved();document.querySelectorAll('[data-fmh-wishlist]').forEach(function(button){var yes=!!items[button.dataset.handle];button.classList.toggle('is-saved',yes);button.setAttribute('aria-pressed',String(yes));button.setAttribute('aria-label',(yes?'Remove saved item: ':'Save ')+(button.dataset.title||'product'));});}
  document.addEventListener('click',function(e){var b=e.target.closest('[data-fmh-wishlist]');if(!b)return;var items=saved(),key=b.dataset.handle;if(items[key])delete items[key];else items[key]={title:b.dataset.title,url:b.dataset.url};try{localStorage.setItem('fmh-saved-products',JSON.stringify(items));}catch(err){}updateHearts();});
  function init(){document.querySelectorAll('[data-fmh-tabs]').forEach(initTabs);updateHearts();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);

  // Dropdown parents are buttons, never links to the all-products page.
  function closeDropdowns(except){
    document.querySelectorAll('.fmh-nav-item.is-open').forEach(function(item){
      if(item===except)return;
      item.classList.remove('is-open');
      var b=item.querySelector('[data-fmh-dropdown-trigger]');
      if(b)b.setAttribute('aria-expanded','false');
    });
  }
  document.addEventListener('click',function(event){
    var trigger=event.target.closest('[data-fmh-dropdown-trigger]');
    if(trigger){
      event.preventDefault();
      var item=trigger.closest('.fmh-nav-item');
      var shouldOpen=!item.classList.contains('is-open');
      closeDropdowns(item);
      item.classList.toggle('is-open',shouldOpen);
      trigger.setAttribute('aria-expanded',String(shouldOpen));
    } else if(!event.target.closest('.fmh-nav-item')){
      closeDropdowns(null);
    }
  });
  document.addEventListener('keydown',function(event){
    var trigger=event.target.closest('[data-fmh-dropdown-trigger]');
    if(trigger&&event.key==='ArrowDown'){
      event.preventDefault();
      closeDropdowns(null);
      var item=trigger.closest('.fmh-nav-item');
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded','true');
      var first=item.querySelector('.fmh-submenu a');
      if(first)first.focus();
    }
    if(event.key==='Escape'){
      var opened=event.target.closest('.fmh-nav-item.is-open');
      if(opened){
        var opener=opened.querySelector('[data-fmh-dropdown-trigger]');
        closeDropdowns(null);
        if(opener)opener.focus();
      }
    }
  });
  document.addEventListener('focusin',function(event){
    if(!event.target.closest('.fmh-nav-item'))closeDropdowns(null);
  });
})();